export const shiftCalendarDate = (iso, days) => {
  const date = new Date(`${iso}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};
export const defaultCalendarRange = () => {
  const parts = new Intl.DateTimeFormat("en", {timeZone:"Europe/Helsinki",year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(new Date());
  const part = type => parts.find(value=>value.type===type).value;
  const today = `${part("year")}-${part("month")}-${part("day")}`;
  return {start:today,end:shiftCalendarDate(today,90)};
};
export const validCalendarRange = ({start,end}) => {
  if (![start,end].every(value=>/^\d{4}-\d{2}-\d{2}$/.test(value))) return false;
  const first = Date.parse(`${start}T12:00:00Z`), last = Date.parse(`${end}T12:00:00Z`);
  return Number.isFinite(first) && Number.isFinite(last) && !start.startsWith("0000") && !end.startsWith("0000") &&
    new Date(first).toISOString().slice(0,10)===start && new Date(last).toISOString().slice(0,10)===end && last >= first && (last-first)/86400000 < 366;
};
